import { useEffect, useState } from "react";
import { api } from "./api";
import { Btn, Field, TextArea, TextInput, Toggle, useSaveState } from "./atoms";

export default function SeoPage() {
  const [routes, setRoutes] = useState(null);
  const [active, setActive] = useState(null);
  const { saving, saved, error, wrap } = useSaveState();

  useEffect(() => {
    api.seoList().then((rs) => {
      setRoutes(rs);
      setActive(rs[0] || null);
    });
  }, []);

  if (!routes) return <div className="text-sm text-neutral-500">Loading…</div>;
  if (!active) return <div className="text-sm text-neutral-500">No routes yet.</div>;

  const set = (k, v) => setActive({ ...active, [k]: v });
  const save = () =>
    wrap(async () => {
      // Standalone SEO table uses a single "Save" button — treat it as
      // Publish (live metadata update), matching its long-standing behaviour.
      const updated = await api.seoUpdate(active, true);
      setRoutes(routes.map((r) => (r.route === updated.route ? updated : r)));
      setActive(updated);
    });

  return (
    <div data-testid="admin-seo" className="pb-20">
      <div className="flex items-center justify-between mb-9">
        <div>
          <div className="text-[0.62rem] font-bold tracking-[0.3em] uppercase text-[#F4D64E]">SEO</div>
          <h1 className="mt-3 font-display text-3xl font-black tracking-[-0.025em]">Per-page metadata</h1>
        </div>
        <div className="flex items-center gap-3">
          {saved ? <span className="text-[0.7rem] text-[#F4D64E]">Saved ✓</span> : null}
          {error ? <span className="text-[0.7rem] text-red-400">{error}</span> : null}
          <Btn onClick={save} disabled={saving} data-testid="seo-save">{saving ? "Saving…" : "Save"}</Btn>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
        <aside className="lg:col-span-1">
          <ul className="space-y-1">
            {routes.map((r) => (
              <li key={r.route}>
                <button
                  type="button"
                  onClick={() => setActive(r)}
                  className={`w-full text-left px-3 py-2.5 rounded-md text-[0.78rem] font-mono transition-colors ${
                    active.route === r.route
                      ? "bg-[#F4D64E]/10 text-[#F4D64E]"
                      : "text-neutral-400 hover:text-white hover:bg-white/[0.04]"
                  }`}
                >
                  {r.route}
                </button>
              </li>
            ))}
          </ul>
        </aside>

        <div className="lg:col-span-3 space-y-5">
          <Field label="Route" hint="Frontend path"><TextInput value={active.route} onChange={() => {}} disabled /></Field>
          <Field label="Meta title"><TextInput value={active.title} onChange={(v) => set("title", v)} /></Field>
          <Field label="Meta description"><TextArea value={active.description} onChange={(v) => set("description", v)} rows={3} /></Field>
          <Field label="Open Graph title"><TextInput value={active.og_title} onChange={(v) => set("og_title", v)} /></Field>
          <Field label="Open Graph description"><TextArea value={active.og_description} onChange={(v) => set("og_description", v)} rows={3} /></Field>
          <Field label="Open Graph image URL"><TextInput value={active.og_image} onChange={(v) => set("og_image", v)} /></Field>
          <Field label="Canonical URL"><TextInput value={active.canonical} onChange={(v) => set("canonical", v)} /></Field>
          <Toggle value={!!active.noindex} onChange={(v) => set("noindex", v)} label="Noindex" />
        </div>
      </div>
    </div>
  );
}
